import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

const resources = {
  de: { translation: de },
  en: { translation: en }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'de', // Default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false // React already escapes
  },
  react: {
    useSuspense: false
  }
});

export default i18n;
